import '@/index.css';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ThemeProvider } from '@/context/ThemeContext';
import { ThemeToggle } from '@/components/ThemeToggle';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import WorkPage from '@/pages/WorkPage';
import ClientsPage from '@/pages/ClientsPage';
import FounderJourneyPage from '@/pages/FounderJourneyPage';
import ProductsPage from '@/pages/ProductsPage';
import RecognitionPage from '@/pages/RecognitionPage';
import ContactPage from '@/pages/ContactPage';
import BlogDetailPage from '@/pages/BlogDetailPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import SectionsManager from '@/pages/admin/SectionsManager';
import MediaLibrary from '@/pages/admin/MediaLibrary';
import SiteSettings from '@/pages/admin/SiteSettings';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/work" element={<Layout><WorkPage /></Layout>} />
            <Route path="/clients" element={<Layout><ClientsPage /></Layout>} />
            <Route path="/journey" element={<Layout><FounderJourneyPage /></Layout>} />
            <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
            <Route path="/recognition" element={<Layout><RecognitionPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/blog/:id" element={<Layout><BlogDetailPage /></Layout>} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="sections" element={<SectionsManager />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="settings" element={<SiteSettings />} />
            </Route>
          </Routes>
          <ThemeToggle />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;